import { Tag } from '@luminovo/design-system';
import { formatDecimal } from '@luminovo/frontend-utils';
import * as React from 'react';
import type { JSX } from 'react';

export const FormulaValue = React.forwardRef<HTMLHeadingElement, { label: string | number | JSX.Element }>(
    ({ label }, ref) => {
        const formatted = () => {
            if (typeof label === 'number') {
                return formatDecimal(label);
            }
            return label;
        };
        return <Tag ref={ref} color="primary" attention="low" label={formatted()} />;
    },
);
